import { cn } from "@/lib/utils";

interface MobileListEmptyProps {
  className?: string;
  message: string;
}

export const MobileListEmpty = ({
  className,
  message,
}: MobileListEmptyProps) => {
  return (
    <div className={cn("flex justify-center py-8", className)}>
      <div className="text-center text-gray-500">
        <div className="text-base">{message}</div>
      </div>
    </div>
  );
};
